import React from 'react';
import { Button, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface EmptyItemsBoxProps {
    text: string;
    buttonLabel: string;
    onAdd: () => void;
}

// Estado vacío para las listas dinámicas (insumos/opciones/componentes) de los modales
export const EmptyItemsBox: React.FunctionComponent<EmptyItemsBoxProps> = ({ text, buttonLabel, onAdd }) => {
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            spacing={1.5}
            py={4}
            sx={{ border: '2px dashed #D5DDE5', borderRadius: 2 }}
        >
            <Typography variant="body2" color="text.secondary">
                {text}
            </Typography>
            <Button variant="outlined" startIcon={<AddIcon />} onClick={onAdd}>
                {buttonLabel}
            </Button>
        </Stack>
    );
};
